import loadable from '@loadable/component'

const CSContactForm = loadable(() => import('./subpages/contact-form'))
const CSContent = loadable(() => import('./subpages/content'))
const CSCmsContent = loadable(() => import('./subpages/cms-content'))
const CSDashboard = loadable(() => import('./subpages/dashboard'))
const CSFaq = loadable(() => import('./subpages/faq'))
const CSHowTo = loadable(() => import('./subpages/how-to'))
const CSOverview = loadable(() => import('./subpages/overview'))
const CSPressContactForm = loadable(() => import('./subpages/press-contact-form'))
const CSUserGuides = loadable(() => import('./subpages/user-guides'))

export default {
    content: {
        component: CSContent
    },
    cms: {
        component: CSCmsContent
    },
    dashboard: {
        component: CSDashboard
    },
    function: {
        contactForm: {
            component: CSContactForm
        },
        faq: {
            component: CSFaq
        },
        howTo: {
            component: CSHowTo
        },
        pressContactForm: {
            component: CSPressContactForm
        },
        userGuides: {
            component: CSUserGuides
        }
    },
    overview: {
        component: CSOverview
    }
}
